module.exports = __webpack_public_path__ + "assets/images/tamandua_6291baa6a714299740438a93f37f6a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stage-helps/tamandua.png
// module id = 341
// module chunks = 0